import Pusher from 'pusher-js';

// Global Pusher instance shared across the application
let globalPusher: Pusher | null = null;

/**
 * Gets or creates the global Pusher instance
 */
export const getOrCreatePusher = (): Pusher => {
  if (!globalPusher) {
    const PUSHER_KEY =
      process.env.REACT_APP_PUSHER_KEY || '7d93496a6cb894633b32';
    const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER || 'us3';
    globalPusher = new Pusher(PUSHER_KEY, {
      cluster: PUSHER_CLUSTER,
    });
  }
  return globalPusher;
};
